// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3DSEd","paramInput":"JobSimulator_paramInput__qQtj8","input":"JobSimulator_input__2QUGz"};